export const ItemBrandKeys = {
  allItemBrands: ['ItemBrands'] as const,
  listItemBrands: () =>
    [...ItemBrandKeys.allItemBrands, 'listItemBrands'] as const,
  listItemBrand: () =>
    [...ItemBrandKeys.listItemBrands(), {}] as const,
}
